import React from "react";
import PropTypes from "prop-types";
import {
  DRIVER_UNITS_LABEL,
  DRIVER_RETAIL_AMOUNT_LABEL,
} from "../../common/constants";

const DataRow = ({ title, unitQuantity, itemCount, adjustmentsAmount, isFirstRow }) => {
  return (
    <>
      <div className="flex row">
        <div
          className="driver-title"
          style={isFirstRow ? { color: "#0066ff" } : { color: "000000" }}
        >
          {isFirstRow ? <u>{title} </u> : <>{title} </>}
        </div>
      </div>
      <div className="flex row">
        <div className="b-1-3 driver-sales-container">
          <div className="driver-sales-value">{itemCount}</div>
          <div className="driver-sales-label"># of SKUs</div>
        </div>
        <div className="b-1-3 driver-sales-container">
          <div className="driver-sales-value">{unitQuantity}</div>
          <div className="driver-sales-label">{DRIVER_UNITS_LABEL}</div>
        </div>
        <div className="b-1-3 driver-sales-container">
          <div className="driver-sales-value">{adjustmentsAmount}</div>
          <div className="driver-sales-label">{DRIVER_RETAIL_AMOUNT_LABEL}</div>
        </div>
      </div>
      <div className={`border-row top-border-row`} />
    </>
  );
};

DataRow.propTypes = {
  title: PropTypes.node,
  unitQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  itemCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  adjustmentsAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isFirstRow: PropTypes.bool,
};

export default DataRow;
